import axios from 'axios';

export const fetchVorgesetzterUserDataSource = () => axios.get("../json/evoAppsUserInfoDialogController/loadVorg");

export const switchVorgesetzterUserHandler = (vorgesetzterUserId) =>
	axios.post("../json/evoAppsUserInfoDialogController/save-vorgesetzter-user", vorgesetzterUserId)
		.catch(() => {
			alert("Fehler beim Übertragen der Daten. Bitte laden Sie die Seite erneut.");
		});